
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Form, Input, Button, message, Spin, Checkbox } from "antd";
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

// import CreateReport from '../EachAccount/eachaccount';

// import wasabiDarkLogo from '../../../assets/logo/wasabi_header_logo_dark.png';
import wasabiDarkLogo from '../../../assets/logo/amove-dark-logo.svg';

import "./addNewAccount.scss";

class AddNewAccount extends Component{
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        console.log("submit account")
        const { name, description } = this.props.form.getFieldsValue()


        CloudFlyerAPI.user_account.addAccount({
            name,
            description
          })
          .then(function (response) {
            message.success('Account Added Successfully!')
          })
          .catch(function (err) {
            message.error('Something went wrong!')
          })



    }

    render(){
        const { getFieldDecorator } = this.props.form
        return(
            <div className="add-new-account-container">
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo} />
                    </div>

                    <div className="add-account-form">
                        <Form
                        layout="horizontal"
                        onSubmit={this.handleSubmit.bind(this)}
                        className="account-form">
                            <Form.Item>

                                {getFieldDecorator('name')(
                                <Input
                                    placeholder="Account Name"
                                    className="account-input"
                                />
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator('description')(
                                <Input
                                    placeholder="Description"
                                    type="text"
                                    className="account-input"
                                />
                                )}

                            </Form.Item>
                            <Form.Item>
                                <Button
                                    className="account-btn"
                                    type="primary"
                                    size="large"
                                    loading={this.state.loading}
                                    htmlType="submit"
                                    block>
                                    Add New Account
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    )(Form.create()(AddNewAccount))
)

